import { VStack } from '@chakra-ui/react';
import React from 'react';

import { CreditFacilityDocumentsHistoryTable } from './CreditFacilityDocumentsHistoryTable';
import { CreditFacilityUploadDocumentForm } from './CreditFacilityDocumentUploadDrawer';
import { Typography } from '~/packages/common-frontend/components/Typography';
import { useGetCapitalProviderOptions } from '~/packages/credit-facility/hooks/useCapitalProviders';

export const CreditFacilityDocumentsHistoryAndUploadContainer = ({
  creditFacilityId,
}: {
  creditFacilityId: string;
}) => {
  const capitalProviderOptions = useGetCapitalProviderOptions(creditFacilityId);

  return (
    <VStack width="100%" align="left" gap="2rem">
      <Typography variant="section-subtitle" trim>
        Upload new documents
      </Typography>
      <CreditFacilityUploadDocumentForm
        capitalProviderOptions={capitalProviderOptions}
        creditFacilityId={creditFacilityId}
      />
      <CreditFacilityDocumentsHistoryTable
        creditFacilityId={creditFacilityId}
      />
    </VStack>
  );
};
